import { makeStyles } from "@mui/styles";

const AccountManagementTermsOfServiceStyles = makeStyles((theme) => ({
  backToContainer: {
    marginTop: 13,
    marginBottom: 60,
    [theme.breakpoints.down('md')]: {
      marginRight: `45%`
    },
    [theme.breakpoints.between("sm", 'lg')]: {
      marginRight: `60%`
    },
    [theme.breakpoints.between("md", 'xl')]: {
      marginRight: `74%`
    },
    [theme.breakpoints.between("lg", "xl")]: {
      marginRight: `65%`
    },
    [theme.breakpoints.up("xl")]: {
      marginRight: `55%`
    }
  },
  privacyPolicyTitle: {
    marginBottom: 40
  },
  secureInformationContainer: {
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
      marginBottom: 25
    },
    [theme.breakpoints.between("md", 'xl')]: {
      marginTop: 340,
      marginBottom: 81
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: 135,
      marginBottom: 42
    }
  }
}));

export default AccountManagementTermsOfServiceStyles;
